// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CtaDevis from "./components/CtaDevis";

// Pages
import About from "./pages/About";
import AccesClients from "./pages/AccesClients";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";
import Contact from "./pages/Contact";
import Galerie from "./pages/Galerie";
import MentionsLegales from "./pages/MentionsLegales";
import Services from "./pages/Services";

// GA
import { pageview } from "./analytics/ga";

// Styles
import "./App.css";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow" role="main">
        <Routes>
          {/* ✅ Home : comme tu n'as pas Home.js, on redirige / vers /galerie */}
          <Route path="/" element={<Navigate to="/galerie" replace />} />

          {/* Pages */}
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/acces-clients" element={<AccesClients />} />

          {/* Légal */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/confidentialite" element={<Confidentialite />} />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/galerie" replace />} />
        </Routes>
      </main>

      <CtaDevis />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}